// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    loading1: false
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    setLoading1(state, value) {
      state.loading1 = value
    }
  },
  actions: {
    showLoading({ commit }) {
      commit('setLoading', true)
    },
    hideLoading({ commit }) {
      commit('setLoading', false)
    },
     showLoading({ commit }) {
      commit('setLoading1', true)
    },
    hideLoading1({ commit }) {
      commit('setLoading1', false)
    }
  }
})